<template>
    <el-dialog
        class="taxClassCodeDialog"
        title="商品和服务税收分类编码"
        :visible.sync="visibleDialog"
        top="4%"
        width="30%"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        :modal="false"
        >
        <el-input placeholder="请输入关键字" v-model="searchValue" clearable class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
        <el-tree
            ref="treeList"
            style="height: 300px; overflow: overlay;"
            :props="defaultProps"
            :data="treeData"
            :load="loadNode"
            v-loading="loading"
            :highlight-current="true"
            node-key="taxCode"
             lazy
             check-strictly
             show-checkbox
             @check-change="handleCheckChange"
             @node-click="handleNodeClick"
            >
        </el-tree>
        <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="confirmDialog">确 定</el-button>
  </span>
    </el-dialog>
</template>

<script>
import { queryTaxClassInfo } from '@/modules/transport/bms/api/invoiceRegistrationApi.js';

export default {
    name: 'TaxClassCodeDialog',
    data() {
        return {
            treeData: [],
            visibleDialog: false,
            defaultProps: {
                label: 'taxName',
                isLeaf: 'isLeaf',
                disabled: 'availableStatus'
            },
            currentNodeData: null,
            searchValue: '',
            editCheckId: '',
            loading: false
        };
    },
    methods: {
        openDialog(flag, checkData) {
            this.visibleDialog = flag;
            if (checkData) {
                this.editCheckId = checkData;
                this.$nextTick(() => {
                    this.$refs.treeList.setCheckedKeys([checkData]);
                });
            } else {
                this.editCheckId = '';
                this.$nextTick(() => {
                    this.$refs.treeList.setCheckedKeys([]);
                });
            }
        },
        handleSearch() {
            let params;
            if (this.searchValue) {
                params = {
                    taxName: this.searchValue
                };
            } else {
                params = {
                    parentTaxCode: '-1',
                    taxCode: ''
                };
            }
            this.loading = true;
            queryTaxClassInfo(params).then((res) => {
                if (res && +res.code === 0) {
                    const data = res.data || [];
                    data.forEach(node => {
                        node.isLeaf = !!node.isLeaf;
                        node.availableStatus = !node.availableStatus;
                    });
                    this.treeData = data;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        loadNode(node, resolve) {
            const params = {
                parentTaxCode: '-1',
                taxCode: ''
            };
            if (node.level > 0) {
                params.parentTaxCode = node.data.taxCode;
            };
            this.loading = true;
            queryTaxClassInfo(params).then((res) => {
                if (res && +res.code === 0) {
                    const data = res.data || [];
                    data.forEach(node => {
                        node.isLeaf = !!node.isLeaf;
                        node.availableStatus = !node.availableStatus;
                    });
                    resolve(data);
                }
            }).catch(() => resolve([])).finally(() => {
                this.loading = false;
            });
        },
        closeDialog() {
            this.clear();
            this.$emit('closeDialog', false);
        },
        clear() {
            this.visibleDialog = false;
        },
        confirmDialog() {
            const checkedNodes = this.$refs.treeList.getCheckedNodes() || [];
            if (!checkedNodes.length) {
                return this.$message.warning('请选择一条数据');
            }
            this.$emit('confirmDialog', checkedNodes[0]);
            this.clear();
        },
        handleNodeClick(item, node, self) { // 自己定义的editCheckId，防止单选出现混乱
            if (item.isLeaf && !item.availableStatus) {
                this.editCheckId = item.taxCode;
                this.$refs.treeList.setCheckedKeys([item.taxCode]);
            }
        },
        handleCheckChange(item, node, self) {
            if (node === true) {
                this.editCheckId = item.taxCode;
                this.$refs.treeList.setCheckedKeys([item.taxCode]);
            } else {
                if (this.editCheckId === item.taxCode) {
                    this.$refs.treeList.setCheckedKeys([item.taxCode]);
                }
            }
        }
    },
    watch: {
    }
};
</script>

<style lang="less" scoped>
    .taxClassCodeDialog{

    }
    .custom-tree-node_input {
        width: 30px;
        margin-left: 10px;
        .el-input__inner {
            height: 19px;
        }
    }
    /deep/ .el-tree-node {
        .is-leaf + .el-checkbox .el-checkbox__inner{
            display: inline-block;
        }
        .el-checkbox .el-checkbox__inner{
            display: none;
        }
    }
</style>
<style scoped>
</style>
